import { all, call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { showLoader, hideLoader } from "../actions/app-action-types";
import {
  LOGIN_USER,
  loginUserFailure,
  loginUserSuccess,
  REMOVE_LOGIN_DATA,
  removeLoginData,
  GET_ALL_MODEL,
  getAllModelFailure,
  getAllModelSuccess,
  getAllEditorsFailure,
  GET_ALL_EDITORS,
  getAllEditorsSuccess,
  ADD_EDITOR,
  UPDATE_EDITOR,
  setUserDataSuccess,
  SET_USER_DATA,
} from "../actions/user-action-types";
import {
  LoginUser,
  GetUser,
  GetAllModels,
  GetAllEditors,
  AddEditor,
  UpdateEditor,
} from "../api";
import moment from "moment";
import { USER_ROLES } from "../constant";

function* loginUser(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => LoginUser(val.payload));
    localStorage.setItem("token", `Bearer ${result.accessToken}`);
    localStorage.setItem("LastTokenRefresh", moment().toDate().getTime() + "");
    localStorage.setItem("LastLogin", moment().toDate().getTime() + "");
    const user = yield call(() => GetUser({ fid: result?.fid }));
    localStorage.setItem("userData", JSON.stringify(user));
    const permissions = {
      appIDs: [],
      moduleIDs: [],
      submoduleIDs: [],
      featureIDs: [],
    };
    const recievedParams = user.Role.permissions.split("_");
    const userRole = user.Role.id;
    const [appID, moduleID, submoduleID, featureID] = recievedParams;
    permissions.appIDs.push(appID);
    permissions.moduleIDs.push(moduleID);
    permissions.submoduleIDs.push(submoduleID);
    permissions.featureIDs.push(featureID);
    if (permissions.appIDs.includes("3") || userRole === USER_ROLES.editor.id) {
      yield put(
        loginUserSuccess({
          result: result,
          userData: user,
          permissions: permissions,
        })
      );
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("LastTokenRefresh");
      localStorage.removeItem("LastLogin");
      toast.error("User Not Allowed to Login", {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(loginUserFailure({ error: "User Not Allowed to Login" }));
    }
  } catch (error) {
    localStorage.removeItem("token");
    localStorage.removeItem("LastTokenRefresh");
    localStorage.removeItem("LastLogin");
    yield put(loginUserFailure({ error }));
  }
  yield put(hideLoader());
}

// Store User Data
function* storeUserData(val) {
  const user = val.payload;
  const permissions = {
    appIDs: [],
    moduleIDs: [],
    submoduleIDs: [],
    featureIDs: [],
  };
  const recievedParams = user.Role.permissions.split("_");
  const [appID, moduleID, submoduleID, featureID] = recievedParams;
  permissions.appIDs.push(appID);
  permissions.moduleIDs.push(moduleID);
  permissions.submoduleIDs.push(submoduleID);
  permissions.featureIDs.push(featureID);
  yield put(
    setUserDataSuccess({
      userData: user,
      permissions: permissions,
    })
  );
}

// Get All Editors
function* getAllEditors(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => GetAllEditors(val.payload));
    yield put(getAllEditorsSuccess(result ?? {}));
  } catch (error) {
    yield put(getAllEditorsFailure({ error }));
  }
  yield put(hideLoader());
}

// Get All Models
function* getAllModels() {
  try {
    const result = yield call(GetAllModels);
    console.log({ result });
    yield put(getAllModelSuccess(result?.nodes ?? []));
  } catch (error) {
    yield put(getAllModelFailure({ error }));
  }
}

// Add Editor
function* addEditor(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => AddEditor(val.payload.params));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

// Update Editor
function* updateEditor(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => UpdateEditor(val.payload.params));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

// Combine all user action into one saga function.
function* User() {
  yield all([
    takeLatest(LOGIN_USER, loginUser),
    takeLatest(SET_USER_DATA, storeUserData),
    takeLatest(REMOVE_LOGIN_DATA, removeLoginData),
    takeLatest(GET_ALL_MODEL, getAllModels),
    takeLatest(GET_ALL_EDITORS, getAllEditors),
    takeLatest(ADD_EDITOR, addEditor),
    takeLatest(UPDATE_EDITOR, updateEditor),
  ]);
}

export default User;
